<template>
  <article
    v-click-outside="closeMenu"
    class="parking-summary-card"
    :class="{'parking-summary-card_selected': selected}"
    role="button"
    tabindex="0"
    :aria-pressed="String(selected)"
    @click="$emit('select', parking)"
    @keydown.enter.self.prevent="$emit('select', parking)"
    @keydown.space.self.prevent="$emit('select', parking)"
    @keydown.esc.stop="closeMenu"
  >
    <div class="parking-summary-card__header">
      <span
        class="parking-summary-card__color"
        :style="{'--parking-summary-color': parkingColor}"
      />
      <h3 class="parking-summary-card__title">
        {{ title }}
      </h3>
      <button
        class="parking-summary-card__menu"
        type="button"
        :aria-label="`Действия с парковкой ${title}`"
        :aria-expanded="String(isMenuOpen)"
        aria-haspopup="true"
        @click.stop="isMenuOpen = !isMenuOpen"
      >
        <span />
        <span />
        <span />
      </button>

      <div v-if="isMenuOpen" class="parking-summary-card__dropdown" @click.stop>
        <button type="button" @click="editParking">
          Редактировать
        </button>
        <button type="button" class="is-danger" @click="deleteParking">
          Удалить
        </button>
      </div>
    </div>

    <div class="parking-summary-card__availability">
      <span>Свободно мест</span>
      <strong>{{ freeSpots }} из {{ totalSpots }}</strong>
    </div>
  </article>
</template>

<script>
import {PARKING_COLORS} from "@/components/pacs/analytics/parkingDetection/parkingComplexConfig.js";

/** Краткая карточка парковки внутри раскрытого комплекса. */
export default {
  name: "ParkingSummaryCard",
  props: {
    parking: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    title() {
      return this.parking.name || this.parking.title || "Без названия";
    },
    parkingColor() {
      const color = PARKING_COLORS.find(option => option.value === this.parking.color);
      return color ? color.hex : this.parking.color || PARKING_COLORS[0].hex;
    },
    totalSpots() {
      const totalSpots = [
        this.parking.total_spots_count,
        this.parking.parking_spots_count,
        this.parking.spots_count,
      ].find(value => value !== null && typeof value !== "undefined");
      return Number(totalSpots || 0);
    },
    freeSpots() {
      const freeSpots = [
        this.parking.free_spots_count,
        this.parking.free_count,
      ].find(value => value !== null && typeof value !== "undefined");
      return Number(freeSpots || 0);
    },
  },
  methods: {
    closeMenu() {
      this.isMenuOpen = false;
    },
    editParking() {
      this.closeMenu();
      this.$emit("edit", this.parking);
    },
    deleteParking() {
      this.closeMenu();
      this.$emit("delete", this.parking);
    },
  },
};
</script>
